import 'ress'  // css reset
import './assets/main.css'

import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from './App.vue';
import router from './router';
import {config, getEnv} from "@/env-config";
import { initDatasetFromQuery } from './dataset'

const pinia = createPinia();

// determine dataset id override from query param
initDatasetFromQuery();

// set environment label in title for non-prod envs
const env = getEnv();
if (env !== "prod") {
    document.title = `${document.title} [${env.toUpperCase()}]`;
}

document.documentElement.setAttribute('data-theme', localStorage.getItem('theme') || 'light');

// initial microsoft clarity if configured
const clarityProjectId = config.clarityProjectId;
if (clarityProjectId) {
    (function(c: any,l: any,a: any,r: any,i: any,t?: any,y?: any){
        c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
        t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
        y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
    })(window, document, "clarity", "script", config.clarityProjectId);
}

const app = createApp(App);

app.use(router);
app.use(pinia);

app.mount('#app');
